"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRegistrationConfigQuerySchema = exports.updateRegistrationFieldConditionRuleSchema = exports.createRegistrationFieldConditionRuleSchema = exports.upsertRegistrationFieldConfigOverrideSchema = exports.upsertRegistrationFieldConfigSchema = exports.attachRegistrationFieldValidationRuleSchema = exports.updateRegistrationValidationRuleSchema = exports.createRegistrationValidationRuleSchema = exports.updateRegistrationFieldDefinitionSchema = exports.createRegistrationFieldDefinitionSchema = exports.reorderRegistrationSectionsSchema = exports.updateRegistrationSectionSchema = exports.createRegistrationSectionSchema = exports.registrationDataBindingSchema = exports.REGISTRATION_PATIENT_CATEGORIES = exports.REGISTRATION_OVERRIDE_SCOPES = exports.REGISTRATION_FIELD_WIDTHS = exports.REGISTRATION_CONDITION_EFFECTS = exports.REGISTRATION_CONDITION_OPERATORS = exports.REGISTRATION_FIELD_VISIBILITIES = exports.REGISTRATION_FIELD_REQUIREMENTS = exports.REGISTRATION_MODES = exports.REGISTRATION_VALIDATION_RULE_TYPES = exports.REGISTRATION_FIELD_TYPES = void 0;
const zod_1 = require("zod");
exports.REGISTRATION_FIELD_TYPES = [
    'TEXTBOX', 'TEXTAREA', 'DROPDOWN', 'RADIO', 'CHECKBOX', 'TOGGLE', 'DATE', 'TIME', 'NUMBER',
    'PHONE', 'EMAIL', 'SEARCH_LOOKUP', 'MULTI_SELECT', 'FILE_UPLOAD', 'PHOTO_CAPTURE', 'SIGNATURE', 'BIOMETRIC',
];
exports.REGISTRATION_VALIDATION_RULE_TYPES = [
    'REQUIRED', 'REGEX', 'MIN_LENGTH', 'MAX_LENGTH', 'UNIQUE', 'AGE_VALIDATION',
    'PHONE_VALIDATION', 'EMAIL_VALIDATION', 'GOVERNMENT_ID_VALIDATION', 'CUSTOM',
];
exports.REGISTRATION_MODES = ['QUICK', 'DETAILED', 'BOTH'];
exports.REGISTRATION_FIELD_REQUIREMENTS = ['REQUIRED', 'OPTIONAL'];
exports.REGISTRATION_FIELD_VISIBILITIES = ['VISIBLE', 'HIDDEN'];
exports.REGISTRATION_CONDITION_OPERATORS = ['EQUALS', 'NOT_EQUALS', 'IN', 'LESS_THAN', 'GREATER_THAN'];
exports.REGISTRATION_CONDITION_EFFECTS = ['VISIBILITY', 'REQUIREMENT'];
exports.REGISTRATION_FIELD_WIDTHS = ['ONE_THIRD', 'HALF', 'TWO_THIRD', 'FULL'];
exports.REGISTRATION_OVERRIDE_SCOPES = ['ROLE', 'DEPARTMENT', 'PATIENT_CATEGORY', 'CORPORATE_ACCOUNT', 'BRANCH'];
exports.REGISTRATION_PATIENT_CATEGORIES = [
    'SELF_PAY', 'CORPORATE', 'INSURANCE', 'GOVERNMENT_SCHEME', 'INTERNATIONAL', 'EMPLOYEE', 'DEPENDENT',
];
exports.registrationDataBindingSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('scalar'), path: zod_1.z.string().min(1) }),
    zod_1.z.object({ kind: zod_1.z.literal('contactArray'), contactType: zod_1.z.enum(['PHONE', 'EMAIL']) }),
    zod_1.z.object({ kind: zod_1.z.literal('addressArray'), addressType: zod_1.z.enum(['CURRENT', 'PERMANENT', 'TEMPORARY']), field: zod_1.z.string().min(1) }),
    zod_1.z.object({
        kind: zod_1.z.literal('sideTable'),
        table: zod_1.z.enum(['identityDocument', 'recordProtection', 'emergencyContact', 'guardian', 'socialHistory', 'communicationPreference']),
        field: zod_1.z.string().min(1).optional(),
        lookupValueId: zod_1.z.string().uuid().optional(),
    }),
]);
exports.createRegistrationSectionSchema = zod_1.z.object({
    code: zod_1.z.string().min(1).max(50),
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().optional(),
    displayOrder: zod_1.z.number().int().optional(),
    isEnabled: zod_1.z.boolean().optional(),
});
exports.updateRegistrationSectionSchema = exports.createRegistrationSectionSchema.partial();
exports.reorderRegistrationSectionsSchema = zod_1.z.object({
    sectionIds: zod_1.z.array(zod_1.z.string().uuid()).min(1),
});
exports.createRegistrationFieldDefinitionSchema = zod_1.z.object({
    sectionId: zod_1.z.string().uuid(),
    fieldCode: zod_1.z.string().min(1).max(100),
    fieldName: zod_1.z.string().min(1).max(150),
    fieldType: zod_1.z.enum(exports.REGISTRATION_FIELD_TYPES),
    dataBindingPath: exports.registrationDataBindingSchema.nullable().optional(),
    placeholder: zod_1.z.string().max(255).optional(),
    helpText: zod_1.z.string().optional(),
    defaultValue: zod_1.z.unknown().optional(),
    isAlwaysRequired: zod_1.z.boolean().optional(),
    isActive: zod_1.z.boolean().optional(),
});
exports.updateRegistrationFieldDefinitionSchema = exports.createRegistrationFieldDefinitionSchema.partial();
exports.createRegistrationValidationRuleSchema = zod_1.z.object({
    code: zod_1.z.string().min(1).max(50),
    name: zod_1.z.string().min(1).max(150),
    ruleType: zod_1.z.enum(exports.REGISTRATION_VALIDATION_RULE_TYPES),
    configJson: zod_1.z.unknown(),
    errorMessage: zod_1.z.string().min(1).max(500),
    isActive: zod_1.z.boolean().optional(),
});
exports.updateRegistrationValidationRuleSchema = exports.createRegistrationValidationRuleSchema.partial();
exports.attachRegistrationFieldValidationRuleSchema = zod_1.z.object({
    validationRuleId: zod_1.z.string().uuid(),
    sortOrder: zod_1.z.number().int().optional(),
});
exports.upsertRegistrationFieldConfigSchema = zod_1.z.object({
    fieldDefinitionId: zod_1.z.string().uuid(),
    registrationMode: zod_1.z.enum(exports.REGISTRATION_MODES),
    displayOrder: zod_1.z.number().int().optional(),
    requirement: zod_1.z.enum(exports.REGISTRATION_FIELD_REQUIREMENTS).optional(),
    visibility: zod_1.z.enum(exports.REGISTRATION_FIELD_VISIBILITIES).optional(),
    isReadOnly: zod_1.z.boolean().optional(),
    defaultValueOverride: zod_1.z.unknown().optional(),
    width: zod_1.z.enum(exports.REGISTRATION_FIELD_WIDTHS).optional(),
    rowGroup: zod_1.z.number().int().optional(),
});
exports.upsertRegistrationFieldConfigOverrideSchema = zod_1.z
    .object({
    overrideScope: zod_1.z.enum(exports.REGISTRATION_OVERRIDE_SCOPES),
    roleId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
    patientCategory: zod_1.z.enum(exports.REGISTRATION_PATIENT_CATEGORIES).optional(),
    // Enterprise Architecture Handbook v1.0, Part IV.2 — additive scope keys.
    corporateId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    requirement: zod_1.z.enum(exports.REGISTRATION_FIELD_REQUIREMENTS).optional(),
    visibility: zod_1.z.enum(exports.REGISTRATION_FIELD_VISIBILITIES).optional(),
    isReadOnly: zod_1.z.boolean().optional(),
    displayOrder: zod_1.z.number().int().optional(),
})
    .refine((data) => (data.overrideScope === 'ROLE' && Boolean(data.roleId)) ||
    (data.overrideScope === 'DEPARTMENT' && Boolean(data.departmentId)) ||
    (data.overrideScope === 'PATIENT_CATEGORY' && Boolean(data.patientCategory)) ||
    (data.overrideScope === 'CORPORATE_ACCOUNT' && Boolean(data.corporateId)) ||
    (data.overrideScope === 'BRANCH' && Boolean(data.branchId)), { message: 'The scope key matching overrideScope is required (roleId/departmentId/patientCategory/corporateId/branchId)' });
exports.createRegistrationFieldConditionRuleSchema = zod_1.z.object({
    fieldDefinitionId: zod_1.z.string().uuid(),
    dependsOnFieldDefinitionId: zod_1.z.string().uuid(),
    operator: zod_1.z.enum(exports.REGISTRATION_CONDITION_OPERATORS),
    expectedValueJson: zod_1.z.unknown(),
    ruleEffect: zod_1.z.enum(exports.REGISTRATION_CONDITION_EFFECTS),
    resultingValue: zod_1.z.string().min(1).max(20),
    isActive: zod_1.z.boolean().optional(),
});
exports.updateRegistrationFieldConditionRuleSchema = exports.createRegistrationFieldConditionRuleSchema.partial();
exports.resolveRegistrationConfigQuerySchema = zod_1.z.object({
    mode: zod_1.z.enum(exports.REGISTRATION_MODES),
    departmentId: zod_1.z.string().uuid().optional(),
    patientCategory: zod_1.z.enum(exports.REGISTRATION_PATIENT_CATEGORIES).optional(),
    // Enterprise Architecture Handbook v1.0, Part IV.2 — additive resolve-context keys.
    corporateId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
});
//# sourceMappingURL=registration-config.schema.js.map